var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.046 512.046",
    height: 512,
    viewBox: "0 0 512.046 512.046",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m183.71 204.878c-1.952 1.061 3.596-1.738-32.559 16.339-5 2.501-8.106 7.526-8.106 13.117v88c0 8.087 6.579 14.666 14.666 14.666h158.121l-38.909-38.909c-6.294 3.135-13.382 4.909-20.878 4.909-34.849 0-57.569-36.805-42.091-67.878z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.951 156.693c4.166-20.343 22.204-35.693 43.76-35.693h68.668c24.629 0 44.666 20.037 44.666 44.666 0 5.591 3.106 10.616 8.107 13.117l31.202 15.602c15.229 7.615 24.69 22.923 24.69 39.949v88c0 15.063-7.503 28.399-18.96 36.493l67.065 67.065c41.948-47.009 64.895-106.771 64.895-169.892 0-140.96-115.049-256-256-256-63.12 0-122.881 22.947-169.891 64.895z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.045,
    cy: 256,
    r: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.833 367h-188.122c-24.629 0-44.666-20.037-44.666-44.666v-88c0-17.026 9.461-32.334 24.689-39.949l23.655-11.827-96.45-96.45c-89.766 100.596-86.596 253.816 10.292 350.705 96.879 96.879 250.097 100.069 350.705 10.292z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.045 322.334v-88c0-5.591-3.106-10.616-8.107-13.117l-31.202-15.602c-15.229-7.615-24.69-22.923-24.69-39.949 0-8.087-6.579-14.666-14.666-14.666h-68.668c-8.087 0-14.666 6.579-14.666 14.666 0 5.906-1.162 11.594-3.284 16.837l31.406 31.406c6.294-3.135 13.382-4.909 20.878-4.909 34.849 0 57.569 36.805 42.091 67.878l59.694 59.694c6.424-1.557 11.214-7.342 11.214-14.238z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhoto);
export default __webpack_public_path__ + "static/media/no-photo.585cd664.svg";
export { ForwardRef as ReactComponent };